const favourites = state => state.favourites;

const favouritesLoading = state => state.favouritesLoading;

const favourite = state => state.favourite;

const favouriteLoading = state => state.favouriteLoading;

const favouritesMeta = state => state.meta;

const checkedFavourite = state => state.checkedFavourite;

const checkedFavouriteLoading = state => state.checkedFavouriteLoading;

export default {
  favourites,
  favouritesLoading,
  favourite,
  favouriteLoading,
  favouritesMeta,
  checkedFavourite,
  checkedFavouriteLoading
};
